/** @format */

import axios from "axios";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { NavLink, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Kunlik from "./Kunlik";
import Oylik from "./Oylik";
import Yillik from "./Yillik";
import Dekadalik from "./Dekadalik";
import AsosiynuqtalarSahifa from "../asosiynuqtalar/AsosiynuqtalarSahifa";
import { header } from "../../../../components/api/Header";
import { getEnv } from "../../../../lib/env";
import "./AsosiyManbalar.css";

const getRegionButtonName = (name = "") => {
  const normalizedName = name.trim();

  if (/^sirdaryo\s+havzasi\s+bo['‘’`]yicha$/i.test(normalizedName)) return "Sirdaryo HB";
  if (/^amudaryo\s+havzasi\s+bo['‘’`]yicha$/i.test(normalizedName)) return "Amudaryo HB";

  return normalizedName.replace(/\s+viloyati$/i, "");
};

function AsosiyManbalar() {
  const location = useLocation();
  const navigate = useNavigate();
  const regions = useSelector((state) => state.data.regions) || [];
  const [regionId, setRegionId] = useState(1);
  const [itbId, setItbId] = useState(null);
  const [itbs, setItbs] = useState([]);
  const [loadingItbs, setLoadingItbs] = useState(false);
  const [itbError, setItbError] = useState(false);
  const regionName = regions.find((item) => String(item.id) === String(regionId))?.name || "Qoraqalpog'iston AR";
  const itbName = itbs.find((item) => String(item.id) === String(itbId))?.name;
  const isRepublic = location.pathname.includes("/asosiymanbalar/respublika");

  useEffect(() => {
    let active = true;
    setLoadingItbs(true);
    setItbError(false);
    axios.get(getEnv("REACT_APP_BASE_URL") + "/v1/republik/asosiymanbalar/itblar", {
      ...header(), params: { regionId },
    }).then(({ data }) => {
      if (active) setItbs(data);
    }).catch(() => {
      if (active) { setItbs([]); setItbError(true); }
    }).finally(() => {
      if (active) setLoadingItbs(false);
    });
    return () => { active = false; };
  }, [regionId]);

  const selectRegion = (id) => {
    if (isRepublic) navigate("/asosiymanbalar/");
    if (String(id) === String(regionId)) return;
    setItbId(null);
    setItbs([]);
    setRegionId(id);
  };
  const tableProps = {
    region: itbName ? regionName + " — " + itbName : regionName,
    regionId, itbId, vaqt: "ertalabki",
  };
  const tabs = [
    ["", "Kunlik"], ["dekada", "10 kunlik"], ["oylik", "Oylik"],
    ["yillik", "Yillik"],
  ];
  const periodBase = isRepublic ? "/asosiymanbalar/respublika" : "/asosiymanbalar";
  const periodTabs = (
    <nav className='asosiy-periods' aria-label='Jadval davri'>
      {tabs.map(([path, label]) => (
        <NavLink key={path} end
          to={path ? periodBase + "/" + path : periodBase}
          className={({ isActive }) => isActive ? "active" : ""}>{label}</NavLink>
      ))}
    </nav>
  );

  return (
    <div className='asosiy_manbalar asosiy-manbalar-republik'>
      <div className='asosiy-navigation'>
        <div className='asosiy-regions' aria-label='Hududlar'>
          <NavLink className='asosiy-republic' to='/asosiymanbalar/respublika'>Respublika</NavLink>
          {regions.map((item) => (
            <button key={item.id} type='button'
              className={!isRepublic && String(regionId) === String(item.id) ? "active" : ""}
              aria-pressed={!isRepublic && String(regionId) === String(item.id)}
              onClick={() => selectRegion(item.id)}>{getRegionButtonName(item.name)}</button>
          ))}
        </div>
        {!isRepublic && <div className='asosiy-itbs' aria-label='Boshqarma va ITBlar'>
          <button type='button' className={itbId === null ? "active" : ""}
            aria-pressed={itbId === null} onClick={() => setItbId(null)}>Asosiy</button>
          {itbs.map((item) => (
            <button key={item.id} type='button'
              className={String(itbId) === String(item.id) ? "active" : ""}
              aria-pressed={String(itbId) === String(item.id)}
              onClick={() => setItbId(item.id)}>{item.name}</button>
          ))}
          {loadingItbs && <span className='text-muted'>Yuklanmoqda...</span>}
          {itbError && <span className='text-danger'>ITBlar ro‘yxatini yuklab bo‘lmadi.</span>}
        </div>}
      </div>
      <Routes>
        <Route path='/' element={<Kunlik {...tableProps} periodTabs={periodTabs} />} />
        <Route path='/dekada' element={<Dekadalik {...tableProps} periodTabs={periodTabs} />} />
        <Route path='/oylik' element={<Oylik {...tableProps} periodTabs={periodTabs} />} />
        <Route path='/yillik' element={<Yillik {...tableProps} periodTabs={periodTabs} />} />
        <Route path='/respublika' element={<AsosiynuqtalarSahifa periodTabs={periodTabs} />} />
        <Route path='/respublika/dekada' element={<Dekadalik region='Respublika' endpoint='/v1/republik/asosiy/dekadalik' periodTabs={periodTabs} />} />
        <Route path='/respublika/oylik' element={<Oylik region='Respublika' endpoint='/v1/republik/asosiy/oylik' periodTabs={periodTabs} />} />
        <Route path='/respublika/yillik' element={<Yillik region='Respublika' endpoint='/v1/republik/asosiy/yillik' periodTabs={periodTabs} />} />
      </Routes>
    </div>
  );
}

export default AsosiyManbalar;
